<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-1-the-journey">
<h1 style="font-family:Arial;font-size:16pt;margin-top:200px;">Part 1<br/> The Journey</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?04649d8a